<template>
  <q-card class="shadow-10">
    <q-card-section class="no-padding">
      <q-banner inline-actions class="bg-blue text-white">
        <span>جزییات بارنامه</span>
        <template v-slot:action>
          <q-btn icon="close" flat round v-close-popup padding="none"/>
        </template>
      </q-banner>
    </q-card-section>
    <q-card-section class="no-padding">
      <q-badge v-if="item.DIFF!==0" rounded :label="`${item.DIFF} روز پیش`"
               :color="item.DIFF<=30?'green-14':'red-14'" text-color="white"/>
      <q-badge v-if="item.DIFF===0" rounded :label="`امروز`"
               color="green-14" text-color="white"/>
      <q-space/>
      <q-chip dense square icon="pin" color="purple" text-color="white" :label="item.WayBillNumber">
        <q-badge v-if="item.Sale_Nums && item.Sale_Nums!==''" color="indigo"
                 class="q-ml-md" text-color="white"
                 :label="item.Sale_Nums.length"/>
      </q-chip>
      <q-space/>
      <q-badge :color="item.ActualSendDatetime?'green-10':'red-10'" text-color="white"
               :label="item.ActualSendDatetime?'تاییدیه حرکت به مقصد اعلان شده است':'تایید حرکت به مقصد اعلان نشده است'"/>
      <q-space/>
      <q-badge v-if="item.SaleExiCountNotConfirm>0"
               color="red-10" text-color="white" class="text-bold"
               :label="` تعداد (${item.SaleExiCountNotConfirm}) فاکتور به مشتری تحویل داده نشده است `"/>
      <q-space/>
      <q-badge v-if="!item.ShabaVerify"
               color="red-10" text-color="white" class="text-bold"
               :label="`شماره شبا تایید نشده است`"/>
      <q-space/>
      <q-badge class="q-ml-xs" rounded color="green-10 text-white" v-if="item.HasFinanceDocument"
               label="سند هزینه صادر شده است"/>
      <q-badge class="q-ml-xs" rounded color="green-10 text-white" v-if="item.IsPay"
               label="پرداخت شده"/>
      <q-chip size="sm" icon="attach_file" color="blue-grey" flat round
              clickable
              label="ضمیمه دارد"
              text-color="white"
              @click="downloadAttachment(item)"
              v-if="$store.state.roles.some(v=>['admin','can_attach_sale_fac_document','user_sell'].includes(v))
                                                && item.HasAttachment">
        <q-tooltip>
          دانلود ضمیمه
        </q-tooltip>
      </q-chip>
    </q-card-section>
    <q-card-section class="no-padding">
      <q-chip dense square :label="item.UserName" icon="support_agent">
        <q-tooltip>
          صادر کننده بارنامه
        </q-tooltip>
      </q-chip>
      <q-chip dense square :label="item.Visitor_Name" icon="person"/>
      <q-card-section v-if="item.Sale_Nums && item.Sale_Nums!==''" class="no-padding">
        <q-space v-if="item.Sale_Nums && item.Sale_Nums!=='' &&
                      lodash.uniq(JSON.parse(item.Sale_Nums).map(item=>item.City_Name)) &&
                      lodash.uniq(JSON.parse(item.Sale_Nums).map(item=>item.City_Name)).length>1"/>
        <q-chip dense square
                v-for="(item, index) in lodash.uniq(JSON.parse(item.Sale_Nums).map(rec=>rec.City_Name))"
                :label="item" :key="index" icon="location_city"/>
      </q-card-section>
      <q-space/>
      <q-chip dense square color="brown" text-color="white" icon="calendar_today"
              :label="item.WayBillDateTime">
        <q-tooltip>
          تاریخ ثبت
        </q-tooltip>
      </q-chip>
      <q-space v-if="item.TransferDateTime"/>
      <q-chip dense v-if="item.TransferDateTime" square color="brown" text-color="white"
              icon="local_shipping"
              :label="item.TransferDateTime">
        <q-tooltip>
          تاریخ ارسال بار
        </q-tooltip>
      </q-chip>
    </q-card-section>
    <q-card-section class="text-center no-padding">
      <table class="no-padding no-margin">
        <thead class="text-center text-bold" style="margin: 0;padding: 0">
        <tr>
          <td>کرایه راننده</td>
          <td>کرایه زیرفاکتور</td>
          <td>
            مبلغ بار
          </td>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td class="text-center" style="padding: 0;margin: 0">
            <q-badge v-if="item.TransferCost" class="q-ml-xs" color="green-10" text-color="white"
                     :label="item.TransferCost.toLocaleString()"/>
          </td>
          <td class="text-center" style="padding: 0;margin: 0">
            <q-badge v-if="item.Transpose_Cost" class="q-ml-xs" color="green-10" text-color="white"
                     :label="item.Transpose_Cost.toLocaleString()"/>
          </td>
          <td class="text-center" style="padding: 0;margin: 0">
            <q-badge v-if="item.Sale_Nums && item.Sale_Nums!==''" class="q-ml-xs" color="green-10" text-color="white"
                     :label="lodash.sumBy(JSON.parse(item.Sale_Nums),'Sale_Pay').toLocaleString()"/>
          </td>
        </tr>
        </tbody>
      </table>
    </q-card-section>
    <q-card-section class="no-padding" v-if="item.Sale_Nums===''">
      {{ item.Title }}
    </q-card-section>
    <q-card-actions class="no-padding">
      <q-btn v-if="item.Sale_Nums && item.Sale_Nums!==''" icon="visibility" color="indigo" flat
             round
             @click="showDetailDialogs">
        <q-tooltip>
          مشاهده اقلام بارنامه
        </q-tooltip>
      </q-btn>
    </q-card-actions>
    <q-dialog v-model="showDetailsDialog" v-if="item" :maximized="$q.screen.lt.md">
      <WayBillItems :way-bill-number="item.WayBillNumber" :details-items="item.Sale_Nums ? JSON.parse(item.Sale_Nums):[]"/>
    </q-dialog>
  </q-card>
</template>

<script>
import {mapActions} from "vuex";
import WayBillItems from "@/components/OrderTrace/WayBillItems.vue";

export default {
  name: "WayBillInfoItem",
  components: {WayBillItems},
  props: {
    item: {
      type: Object,
      default: () => {
      }
    }
  },
  data() {
    return {
      showDetailsDialog:false,
    }
  },
  methods: {
    ...mapActions({}),
    showDetailDialogs() {
      this.showDetailsDialog = true;
    },
  },
  created() {
  }
}
</script>

<style scoped>

</style>